import React, { useContext, useEffect } from 'react'
import ServicesSection from './ServicesSection'
import WhoUs from './WhoUs'
import BlogsSection from './BlogsSection'
import Contactus from './Contactus'
import Questions from './Questions'
import Hero2 from './Hero2'
import { Trans } from 'react-i18next'
import { DirectionContext } from '../Contexts/DirectionContext'
import { Link } from 'react-router-dom'
import Customers from './Customers'
// 
import { ServicesData } from '../ServicesData/ServicesData'

export default function Home() {
    const cardsData = ServicesData
    var ServicesCards = ServicesData.slice(0, 4);
    const { dir } = useContext(DirectionContext)


    return <>
        <div className='HeroArea'>
            <div className="layer"></div>
            <div className="container Hero-Content-container " >
                <div className="row justify-content-center g-4 w-100">
                    <div className="col-lg-8" >
                        <h1><Trans i18nKey="mainHeadLine">تقديم الحلول التشريعية والنظامية المتكاملة باحترافية وكفاءة وجودة عالية.</Trans></h1>
                    </div>
                    <div className="col-md-12">
                        <Link to="/info/contact">
                            <button className='HeroBtn py-3 px-2  py-md-3 px-md-4'>
                                <Trans i18nKey="BookBtn">   احجز استشارتك القانونية الآن </Trans>
                            </button>
                        </Link>

                    </div>
                </div>
            </div>

        </div>
        <div className="container-fluid">
            <section className="section">
                <WhoUs dir={dir} />
            </section>
            <section className="section wow fadeIn" data-wow-delay="1.0s">
                <div className="row justify-content-evenly align-items-end">
                    <div className="col-md-11 headlineContainer ">
                        <h2 className='Title px-2 my-5 wow fadeInLeft' data-wow-delay=".2s" >
                            <div className='indicator'></div>
                            <Trans i18nKey="ServicesTitle"> خدمات قانونية شاملة وفق أعلى المعايير </Trans></h2>
                    </div>
                    <ServicesSection cardsData={ServicesCards} />
                    <div className="col-md-12 text-center">
                        <Link to="/info/services">
                            <button className='HeroBtn p-3 px-4 mt-5'>
                                <Trans i18nKey="ServicesBtn">   عرض جميع الخدمات </Trans>
                            </button>
                        </Link>

                    </div>

                </div>
            </section>
            <section className="section">
                <BlogsSection dir={dir} />
            </section>
            <section className="section">
                <Customers dir={dir} />
            </section>
        </div>
        <section className="section">
            <Contactus dir={dir} />
        </section>
        <div className="container-fluid">
            <section className="section">
                <Questions dir={dir} />
            </section>
        </div>
        <Hero2 />

    </>
}
